import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class TabsTwo extends Component{
    render(){
        let 
        tab1 = "Career Highlights",
        tab2 = "Projects & Consulting",
        tab3 = "Main skills",
        tab4 = "Places I've lived in";
        const { tabStyle } = this.props
        return(
            <div>
                {/* Start Tabs Area */}
                <div className="tabs-area mg-tabs-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs>
                                    <TabList  className={`${tabStyle}`}>
                                        <Tab>{tab1}</Tab>
                                        <Tab>{tab2}</Tab>
                                        <Tab>{tab3}</Tab>
                                        <Tab>{tab4}</Tab>
                                    </TabList>

                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                                <li>
                                                   <a href="https://nespresso.com" target="_blank"><img className="mr--10" src="/assets/images/about/nespresso_logo.png" alt="Nespresso logo" width="30"/>Nespresso Digital Experience <span>- Product Owner</span></a> <span>2025 - Present<br></br>Leading the Design System evolution and rethinking the full, global digital experience while overseeing a dedicated AI track to streamline internal workflows.</span>
                                                </li>
                                                <li>
                                                    <a href="https://www.morningside.ai/" target="_blank"><img className="mr--10" src="/assets/images/about/morningside_logo.png" alt="Morningside AI logo" width="30"/>Morningside AI <span>- Head of AI Product</span></a> <span>2023 - 2025<br></br>Led the development of their flagship AI product, Agentive, while driving AI product strategy across their diverse client portfolio.</span>
                                                </li>
                                                <li>
                                                    <a href="https://forwork.meta.com/" target="_blank"><img className="mr--10" src="/assets/images/about/metafb_logo.png" alt="Meta logo" width="30"/>Meta <span>- Lead Product Designer</span></a> <span>2022 - 2025<br></br>Drove cross-functional teams to innovate and design scalable products, including key contributions to Meta's Workrooms and Quest for Business initiatives.</span>
                                                </li>
                                                <li>
                                                    <a href="https://rover.com" target="_blank"><img className="mr--10" src="/assets/images/about/rover_logo.png" alt="Rover logo" width="30"/>Rover.com <span>- Lead Product Designer & Design Manager</span></a> 2018 - 2022
                                                </li>
                                                <li>
                                                    <a href="" target="_blank">Various startups<span>- Product Designer</span></a> 2013-2018
                                                </li>
                                           </ul>
                                       </div>
                                    </TabPanel>

                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                                <li>
                                                   <a href="https://nespresso.com" target="_blank">Nespresso<span> - Helping Nespresso to rebuild the entire digital experience</span></a> 2025 - Today
                                               </li>
                                                <li>
                                                   <a href="https://boostra.uk/services/ai-transformation" target="_blank">Boostra<span> - AI Transformation & Solutions for Cybersecurity & Tech Scale-ups</span></a> 2025 - Today
                                               </li>
                                                <li>
                                                   <a href="https://agentivehub.com" target="_blank">Agentive<span> - Delivery platform for AI Automation Agency (AAA) owners.</span></a> 2023 - 2025
                                               </li>
                                               <li>
                                                   <a href="https://www.readyrns.com/" target="_blank">ReadyRNs<span> - Immersive AI learning tools you need to perfect your clinical decisions.</span></a> 2023 - 2025
                                               </li>
                                                <li>
                                                   <a href="https://www.ourgen.uk/" target="_blank">ourGen<span> - Peer-to-peer knowledge base of student careers information</span></a> 2021 - Today
                                               </li>
                                                <li>
                                                   <a href="https://worseideas.s3.eu-west-1.amazonaws.com/index.html" target="_blank">Worse Ideas, Ideas Database (discontinued)<span> - Share your ideas to change the world.</span></a> 2019 - 2022
                                               </li>
                                                {/* <li>
                                                   <a href="https://mediboost.s3.eu-west-1.amazonaws.com/index.html" target="_blank">Mediboost (discontinued)<span> - Boost your medical practice's online presence.</span></a> 2019 - 2021
                                               </li> */}
                                           </ul>
                                       </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                {/* <li>
                                                    <a href="/" className="disabled-link">Mentorship and Leadership</a>
                                                    Humans want to be superheroes. I'm there every step of the way to remind them they can be.
                                                </li> */}
                                                <li>
                                                    <a href="/" className="disabled-link">Product Strategy & Ownership<span> - From Vision to Revenue</span></a>
                                                    I don't just manage backlogs; I align technical roadmaps with C-level business goals to define go-to-market strategies for AI products and global platforms.
                                                </li>
                                                <li>
                                                    <a href="/" className="disabled-link">Product Design & Systems <span> - Scalable Systems & Mentorship</span></a>
                                                    Leveraging my background at Meta and Rover, I move beyond simple UI/UX to build robust Design Systems that scale while mentoring teams to elevate their craft.
                                                    </li>
                                                <li>
                                                    <a href="/" className="disabled-link">0-to-1 Building <span> - Founder Mindset</span></a>
                                                    I am an endless builder. From launching my own studio to leading the development of AI products, I thrive in the messy "Zero to One" phase, turning abstract ideas into live products.
                                                </li>
                                                <li>
                                                    <a href="/" className="disabled-link">Technical Fluency <span> - Bridging Code & Design</span></a>
                                                    My proficiency in React, Python, and APIs in general allows me to speak the engineers' language, prototype independent solutions, and ensure product requirements are technically feasible.
                                                </li>
                                                <li>
                                                    <a href="/" className="disabled-link">AI & Workflow Automation <span> - Design Intelligence</span></a>
                                                    I lead AI tracks to automate internal workflows, helping teams reduce busywork and focus on high-impact creativity. I don't just use AI; I build the workflows that make it useful for specific needs.
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                               <li>
                                                   <a href="/" className="disabled-link">Barcelona<span>, Spain</span></a>2016 - Today
                                               </li>
                                               <li>
                                                   <a href="/" className="disabled-link">London<span>, England</span></a> 2013 - 2016
                                               </li>
                                               <li>
                                                   <a href="/" className="disabled-link">Milan<span>, Italy</span></a> 1990 - 2016
                                               </li>
                                           </ul>
                                       </div>
                                    </TabPanel>
                                    
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Tabs Area */}
            </div>
        )
    }
}



export default TabsTwo;